import React from "react";
import {
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  Youtube as YoutubeIcon,
  Twitter as TwitterIcon,
  Pinterest as PinterestIcon,
  Arrow as ArrowIcon,
} from "../../../components/Icons";

const facebookLink = "https://www.facebook.com/AudideMexico";
const instagramLink = "https://www.instagram.com/audidemexico/";
const youtubeLink = "https://www.youtube.com/user/AudideMexico";
const twitterLink = "https://twitter.com/AudideMexico";
const pinterestLink = "https://es.pinterest.com/audidemexico/";

const concecionariosLink =
  "https://www.audi.com.mx/mx/web/es/dealer-locator.html";
const eNewsletterLink = "https://audinewsletter.com.mx/";
const financialServicesLink =
  "https://www.audi.com.mx/mx/web/es/servicios-al-cliente/Audi_Financial_Services.html";
const certificacionesLink =
  "https://www.audi.com.mx/mx/web/es/servicios-al-cliente/certificaciones.html";
const avisoPrivacidadLink =
  "https://www.audi.com.mx/mx/web/es/tools/navigation/layer/legal.html";
const terminosLink =
  "https://www.audi.com.mx/mx/web/es/tools/navigation/layer/imprint.html";
const cookiesLink =
  "https://www.audi.com.mx/mx/web/es/tools/navigation/layer/cookies.html";
const llamadoRevisionLink =
  "https://www.audi.com.mx/mx/web/es/servicios-al-cliente/postventa/recall-llamado-revision.html";

const Footer = () => {
  const getYear = new Date().getFullYear();
  const subirPantalla = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer>
      <div className="c-social v-align-c">
        <span className="v-align-c" onClick={subirPantalla}>
          De vuelta al inicio
          <ArrowIcon />
        </span>
        <div>
          <a href={facebookLink} target="_blank" rel="noopener noreferrer">
            <FacebookIcon />
          </a>
          <a href={instagramLink} target="_blank" rel="noopener noreferrer">
            <InstagramIcon />
          </a>
          <a href={youtubeLink} target="_blank" rel="noopener noreferrer">
            <YoutubeIcon />
          </a>
          <a href={twitterLink} target="_blank" rel="noopener noreferrer">
            <TwitterIcon />
          </a>
          <a href={pinterestLink} target="_blank" rel="noopener noreferrer">
            <PinterestIcon />
          </a>
        </div>
      </div>

      <div className="c-copyright">
        <span>© {getYear} AUDI AG. Todos los derechos reservados.</span>
        <div>
          <ul>
            <li>
              <a
                href={concecionariosLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Concesionarios
              </a>
            </li>
            <li>
              <a
                href={eNewsletterLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                E-Newsletter
              </a>
            </li>
            <li>
              <a
                href={financialServicesLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Audi Financial Services
              </a>
            </li>
            <li>
              <a
                href={certificacionesLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Certificaciones
              </a>
            </li>
            <li>
              <a
                href={avisoPrivacidadLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Aviso de privacidad
              </a>
            </li>
            <li>
              <a href={terminosLink} target="_blank" rel="noopener noreferrer">
                Términos y condiciones
              </a>
            </li>
            <li>
              <a href={cookiesLink} target="_blank" rel="noopener noreferrer">
                Política de Cookies
              </a>
            </li>
            <li>
              <a
                href={llamadoRevisionLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Llamado a revisión
              </a>
            </li>
          </ul>
        </div>
      </div>

      <p className="">
        <span>
          Términos y condiciones por Audi de México
          <br />
          Este sitio es oficial de Volkswagen de México, S.A. de C.V.,
          comercializador de marca Audi en México; la información aquí referida,
          así como las ilustraciones de este sitio están de acuerdo a las
          versiones y equipamientos ofertados por el proveedor dentro de la
          República Mexicana y son las más recientes en el momento de hacer esta
          publicación. Algunas versiones y equipamientos son opcionales, por lo
          que los costos de los vehículos aquí ofertados pueden variar y podrían
          tener un costo extra. Los valores obtenidos sobre rendimientos en
          Ciudad, carretera y combinado son valores obtenidos en pruebas de
          laboratorio bajo condiciones controladas. Para conocer la
          disponibilidad de nuestros productos y para mayor información se
          recomienda acudir a su Distribuidor autorizado Audi dentro de la
          República Mexicana.
        </span>
      </p>
    </footer>
  );
};

export default Footer;
